import { Box } from "@mui/material"
import { CopyIcon } from "@radix-ui/react-icons"
import { useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { TailSpin, ThreeDots } from "react-loader-spinner"
import { RECUPERER_ZONE_COVERTURE_FICHIER, VERIFICATION_ELIGIBILITE } from '../../Utils/constant'
import { find, store } from "../../services/service"
import Kml from "../Widget/Kml"
import { SubmitButton } from "../Widget/SubmitButton"

export const Eligibilite = ({ handleNext }) => {
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [loadingLocalisation, setLoadingLocalisation] = useState(false);
    const [eligible, setEligible] = useState(null)
    const [gettingFile, setGettingFile] = useState(false);
    const [fileZoneCouverte, setFileZoneCouverte] = useState(null);
    const [userLocation, setUserLocation] = useState(null);
    const [debouncedFieldLatitude, setDebouncedFieldLatitude] = useState(latitude);
    const [debouncedFieldLongitude, setDebouncedFieldLongitude] = useState(longitude);

    useEffect(() => {
        setGettingFile(true)
        find(RECUPERER_ZONE_COVERTURE_FICHIER)
            .then((res) => {
                setGettingFile(false);
                setFileZoneCouverte(res.data && res.data.fichier ? res.data.fichier : null)
            })
            .catch((err) => {
                setGettingFile(false);
            });
    }, []);


    const handleClick = () => {
        setLoadingLocalisation(true);
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLoadingLocalisation(false);
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                    setUserLocation([
                        position.coords.latitude,
                        position.coords.longitude,
                    ]);
                    setError(null);
                },
                (error) => {
                    setLoadingLocalisation(false);
                    setError(error.message);
                },
                {
                    timeout: 10000, // Timeout after 10 seconds
                    maximumAge: 0, // No cache
                    enableHighAccuracy: true, // Request high accuracy
                }
            );
        } else {
            setLoadingLocalisation(false);
            setError(
                "La géolocalisation n'est pas prise en charge par ce navigateur."
            );
            console.error("Geolocation not supported by this browser.");
        }
    };
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        if (userLocation) {
            reset({
                latitude: latitude,
                longitude: longitude
            })
        }
    }, [reset, userLocation])

    const submit = (data) => {
        setIsSubmit(true)
        store(VERIFICATION_ELIGIBILITE, 'application/json', data).then((res) => {
            if (res.status === 200) {
                setEligible(res?.data)
                localStorage.setItem('numero', res?.data?.numeroTicket)
                toast.success('Vérification terminée')
                setIsSubmit(false)
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFieldLatitude(latitude);
        }, 2000); // Delay in milliseconds

        // Cleanup the timeout if fieldOne changes before delay is over
        return () => {
            clearTimeout(handler);
        };
    }, [latitude]);

    // Update debouncedFieldTwo after a delay
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFieldLongitude(longitude);
        }, 2000); // Delay in milliseconds

        // Cleanup the timeout if longitude changes before delay is over
        return () => {
            clearTimeout(handler);
        };
    }, [longitude]);

    useEffect(() => {
        if (debouncedFieldLatitude || debouncedFieldLongitude) {
            if (latitude && latitude.length >= 3 && longitude && longitude.length > 3) {
                setUserLocation([
                    latitude,
                    longitude
                ]);
            } else {
            }
        } else {
        }
    }, [debouncedFieldLatitude, debouncedFieldLongitude, latitude, longitude]);

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <div>
                    <p className="my-2">Les zones de couverture de la FTTH</p>
                    {!gettingFile ? <Kml userLocation={userLocation} setLatitude={setLatitude} setLongitude={setLongitude} setUserLocation={setUserLocation} zoneCouverte={fileZoneCouverte} /> : null}
                    {gettingFile ?
                        <div className="w-full h-[500px] flex items-center justify-center">
                            <TailSpin
                                height="40"
                                width="40"
                                color="#000"
                                ariaLabel="tail-spin-loading"
                                radius="2"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={gettingFile}
                            />
                        </div> : null}
                </div>
                <form onSubmit={handleSubmit(submit)} className="w-full  mt-6">
                    {
                        eligible === null ?
                            <>
                                <div className="">
                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Numero client <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input
                                            {...register('numeroClient', { required: true })}
                                            type="number"
                                            min={0}
                                            placeholder="Numero client "
                                            className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>

                                </div>

                                <div className="">
                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Latitude <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input
                                            {...register('latitude', { required: true })}
                                            type="text"
                                            value={latitude}
                                            onChange={(e) => setLatitude(e.target.value)}
                                            placeholder="Latitude "
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>

                                <div className="">
                                    <label className="form-control  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Longitude <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input
                                            {...register('longitude', { required: true })}
                                            type="text"
                                            value={longitude}
                                            onChange={(e) => setLongitude(e.target.value)}
                                            placeholder="Longitude"
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>
                                <span
                                    onClick={handleClick}
                                    className="bg-black text-white btn btn-sm my-4"
                                >
                                    {latitude && longitude && !loadingLocalisation ? (
                                        <div className="">
                                            <h2> Obtenir à nouveau</h2>
                                        </div>
                                    ) : !loadingLocalisation ? (
                                        <h2> Obtenir la position</h2>
                                    ) : (
                                        <div className="flex flex-row items-center justify-center w-full">
                                            <ThreeDots
                                                height="20"
                                                width="40"
                                                radius="9"
                                                color="#000"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={loadingLocalisation}
                                            />
                                        </div>
                                    )}
                                </span>
                                <SubmitButton isSubmit={isSubmit} label={"Verifier l'eligibilité"} />

                            </> : (
                                <div className={`w-full  my-8 border ${eligible?.fttheligible !== 'eligible' ? 'border-red-600' : 'border-green-600'} px-3 py-2 rounded mb-3`}>
                                    <div className="flex gap-2">
                                        <p className="text-lg font-semibold ">Status: </p>
                                        <p className={`text-lg font-bold ${eligible?.fttheligible !== 'eligible' ? 'text-red-600' : 'text-green-600'}`}>{eligible?.fttheligible} </p>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <p className="text-lg font-semibold">Numero de ticket: </p>
                                        <p className={`text-lg ${eligible?.fttheligible !== 'eligible' ? 'text-red-600' : 'text-green-600'}`}>{eligible?.numeroTicket} </p>
                                        <div className="bg-gray-200 p-1 rounded cursor-pointer">
                                            <CopyToClipboard text={eligible?.numeroTicket}
                                                onCopy={() => toast.success('Texte copié')}>
                                                <span><CopyIcon /></span>
                                            </CopyToClipboard>
                                        </div>
                                    </div>
                                    {
                                        eligible?.fttheligible !== 'eligible' ?
                                            <button className='bg-main btn btn-sm' onClick={() => {
                                                setEligible(null)
                                            }}>Reessayer
                                            </button>
                                            : null
                                    }

                                </div>
                            )
                    }


                </form>
            </div>


            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >
                    <Box sx={{ flex: "1 1 auto" }} />
                    {
                        eligible?.fttheligible === 'Non éligible' ?
                            <span
                                className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                                onClick={() => {
                                    window.history.back()
                                }}
                            >
                                Quitter
                            </span> :
                            <button
                                className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                                onClick={handleNext}
                            >
                                Poursuivre
                            </button>
                    }
                </div>
            </div>
        </>
    )
}
